module.exports = __webpack_public_path__ + "static/media/front.277b6157.jpg";